module.exports = __webpack_public_path__ + "static/media/Imagen3.5bbff395.png";